module.exports = __webpack_public_path__ + "img/icon_aside_icon_hover.e779d68a.svg";